import React from 'react';
import { Button } from './ui/Button';
export function CTA() {
  return <section className="py-20 bg-white" data-id="element-165">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <div className="bg-[#F5E6F5] rounded-2xl p-8 md:p-12 lg:p-16 text-center relative overflow-hidden shadow-lg border-2 border-[#9333EA]" data-id="element-167">
          <div className="absolute top-0 left-0 w-24 h-24 bg-[#E5B3E5]/20 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-168"></div>
          <div className="absolute bottom-0 right-0 w-32 h-32 bg-[#E5B3E5]/20 rounded-full translate-x-1/2 translate-y-1/2" data-id="element-169"></div>
          <div className="absolute top-12 right-12 w-12 h-12 bg-[#9333EA]/20 rounded-full hidden md:block" data-id="element-170"></div>
          <div className="relative z-10" data-id="element-171">
            <span className="inline-block px-4 py-1 bg-white text-[#9333EA] text-sm font-medium rounded-full mb-6 shadow-sm border border-[#9333EA]" data-id="element-172">
              Ready to transform your event?
            </span>
            <div className="bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-md mb-8 border-2 border-[#9333EA]" data-id="element-173">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-174">
                Create conferences that{' '}
                <span className="text-[#9333EA]" data-id="element-175">attendees remember</span>
              </h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-176">
                Join event organizers who are building more engaging,
                participatory conferences with Nexio App.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-177">
              <Button size="lg" className="min-w-[180px] shadow-md" href="https://nexioapp.eu/dashboard/register" data-id="element-178">
                Start your free trial
              </Button>
              <Button variant="outline" size="lg" className="min-w-[180px]" href="https://calendar.app.google/6fKsGXEmBQzjPvnc9" data-id="element-179">
                Plan a Demo
              </Button>
            </div>
            <p className="mt-8 text-sm text-gray-500 bg-white/70 inline-block px-4 py-2 rounded-full shadow-sm" data-id="element-180">
              No credit card required. 14-day free trial.
            </p>
          </div>
        </div>
      </div>
    </section>;
}